import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import LoginPage from './components/LoginPage';
import SeatArrangementPage from './pages/SeatArrangementPage';
import PeopleListPage from './pages/PeopleListPage';
import { EditModeProvider } from './contexts/EditModeContext';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // 페이지 로드 시 인증 상태 확인
    const authStatus = localStorage.getItem('isAuthenticated');
    if (authStatus === 'true') {
      setIsAuthenticated(true);
    }
  }, []);

  const handleLogin = (success: boolean) => {
    setIsAuthenticated(success);
  };

  const handleLogout = () => {
    localStorage.removeItem('isAuthenticated');
    setIsAuthenticated(false);
  };

  if (!isAuthenticated) {
    return <LoginPage onLogin={handleLogin} />;
  }

  return (
    <Router>
      <EditModeProvider>
        <Layout onLogout={handleLogout}>
          <Routes>
            <Route path="/" element={<SeatArrangementPage />} />
            <Route path="/people" element={<PeopleListPage />} />
          </Routes>
        </Layout>
      </EditModeProvider>
    </Router>
  );
}

export default App;
